import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './scss/style.scss';
import { UnifiedLoader } from './components/loader';
import Privada from 'routes/Privada';
import Inicio from 'routes/Inicio';
import Principal from 'pages/principal/Principal';
import { LandingPage } from 'pages/landing';
import Registro from 'pages/registro/Registro';
import { SERVER_ROUTE } from 'utils/constants';

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<UnifiedLoader fullScreen text="Cargando..." />}>
        <Routes>
          <Route path="/lideresaccion" element={<LandingPage />} />
          <Route path={`${SERVER_ROUTE}/principal`} element={<Principal />} />
          <Route path={`${SERVER_ROUTE}/registro`} element={<Registro />} />
          <Route path='*'
            element={
              <Privada>
                <Inicio />
              </Privada>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
